Object.assign(window.FazendaRP.Pages.financeiro, {
    renderGaleria: async function (container) {
        container.innerHTML = `
            <div id="galeria-filters" style="display:flex; gap:10px; margin-bottom:20px; flex-wrap:wrap; padding: 15px; background:white; border-radius:8px; box-shadow:0 1px 3px rgba(0,0,0,0.1); align-items:flex-end;">
                 <div style="flex:1; min-width:200px;">
                    <label style="font-size:0.85em; color:#6b7280; display:block; margin-bottom:4px;">Período (Vencimento)</label>
                    <input type="month" id="galeria-filtro-mes" class="form-control" style="width:100%;">
                 </div>
                 <div style="flex:1; min-width:200px;">
                    <label style="font-size:0.85em; color:#6b7280; display:block; margin-bottom:4px;">Parceiro ou Descrição</label>
                    <input type="text" id="galeria-filtro-parceiro" class="form-control" placeholder="Buscar..." style="width:100%;">
                 </div>
                 <div>
                    <button id="btn-galeria-refresh" class="btn btn-primary" style="height:38px; display:flex; align-items:center; gap:5px;">
                        <i class="fas fa-sync-alt"></i> Atualizar
                    </button>
                 </div>
            </div>

            <div id="galeria-grid" style="display:grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap:20px; padding-bottom:40px;">
                <div style="grid-column:1/-1; text-align:center; padding:50px; color:#666;">
                    <i class="fas fa-spinner fa-spin"></i> Carregando galeria...
                </div>
            </div>
        `;

        // Set Default Month (Current)
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const elmDate = container.querySelector('#galeria-filtro-mes');
        elmDate.value = `${yyyy}-${mm}`;

        const loadDocs = async () => {
            const grid = container.querySelector('#galeria-grid');
            grid.innerHTML = '<div style="grid-column:1/-1; text-align:center; padding:50px; color:#666;"><i class="fas fa-spinner fa-spin"></i> Buscando documentos...</div>';

            const [year, month] = elmDate.value.split('-');
            const dtStart = `${year}-${month}-01`;
            const lastDay = new Date(year, month, 0).getDate();
            const dtEnd = `${year}-${month}-${lastDay}`;

            const term = container.querySelector('#galeria-filtro-parceiro').value.toLowerCase();

            // Fetch Lancamentos with Attachments
            const { data: lancs, error } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select(`id, data_vencimento, data_pagamento, descricao, valor, anexos, parceiros(nome)`)
                .neq('anexos', null)
                .gte('data_vencimento', dtStart)
                .lte('data_vencimento', dtEnd)
                .order('data_vencimento', { ascending: false });

            if (error) {
                console.error(error);
                grid.innerHTML = `<div style="color:red; grid-column:1/-1;">Erro ao carregar: ${error.message}</div>`;
                return;
            }

            let allDocs = [];

            lancs.forEach(l => {
                let list = l.anexos;
                if (typeof list === 'string') {
                    try { list = JSON.parse(list); } catch (e) { list = []; }
                }
                if (!Array.isArray(list) || list.length === 0) return;

                // Filter Text
                const pName = l.parceiros ? l.parceiros.nome.toLowerCase() : '';
                const desc = l.descricao ? l.descricao.toLowerCase() : '';
                if (term && !pName.includes(term) && !desc.includes(term)) return;

                // Flatten Documents
                list.forEach((doc, idx) => {
                    allDocs.push({
                        doc,
                        lanc: l,
                        docList: list
                    });
                });
            });

            if (allDocs.length === 0) {
                grid.innerHTML = `<div style="grid-column:1/-1; text-align:center; padding:40px; color:#888; background:#f9fafb; border-radius:8px;">
                    <i class="fas fa-folder-open" style="font-size:2em; margin-bottom:10px; color:#d1d5db;"></i><br>
                    Nenhum documento encontrado neste período.
                </div>`;
                return;
            }

            grid.innerHTML = allDocs.map(item => {
                const ext = item.doc.path.split('.').pop().toLowerCase();
                const isImg = ['jpg', 'jpeg', 'png', 'webp'].includes(ext);

                // Get Thumbnail URL
                const { data } = window.FazendaRP.supabase.storage.from('comprovantes').getPublicUrl(item.doc.path);
                const thumbUrl = data.publicUrl;

                let mediaHtml = '';
                if (isImg) {
                    mediaHtml = `<div style="width:100%; height:140px; overflow:hidden; background:#f3f4f6;">
                        <img src="${thumbUrl}" style="width:100%; height:100%; object-fit:cover; transition:transform 0.3s;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'" loading="lazy">
                    </div>`;
                } else {
                    mediaHtml = `<div style="width:100%; height:140px; display:flex; align-items:center; justify-content:center; background:#fee2e2; color:#ef4444; font-size:2.5em;">
                        <i class="fas fa-file-pdf"></i>
                    </div>`;
                }

                // Date Format
                const dataFmt = item.lanc.data_vencimento ? item.lanc.data_vencimento.split('-').reverse().join('/') : '-';

                return `
                    <div class="doc-card" style="background:white; border:1px solid #e5e7eb; border-radius:8px; cursor:pointer; overflow:hidden; transition:box-shadow 0.2s; position:relative;">
                        ${mediaHtml}
                        <div style="padding:12px;">
                            <div style="font-size:0.75rem; color:#9ca3af; margin-bottom:4px; display:flex; justify-content:space-between;">
                                <span>${dataFmt}</span>
                                <span style="background:#f3f4f6; padding:1px 6px; border-radius:4px; font-size:0.7em;">${ext.toUpperCase()}</span>
                            </div>
                            <div style="font-weight:600; font-size:0.9rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; color:#1f2937; margin-bottom:2px;" title="${item.lanc.descricao}">
                                ${item.lanc.descricao}
                            </div>
                            <div style="font-size:0.8rem; color:#6b7280; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                ${item.lanc.parceiros ? item.lanc.parceiros.nome : 'Sem Parceiro'}
                            </div>
                            <div style="margin-top:8px; font-size:0.9rem; font-weight:700; color:#059669;">
                                R$ ${parseFloat(item.lanc.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                            </div>
                        </div>
                        <div class="hover-overlay" style="position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.05); opacity:0; transition:opacity 0.2s; pointer-events:none;"></div>
                    </div>
                `;
            }).join('');

            // Hover effects
            const cards = grid.querySelectorAll('.doc-card');
            cards.forEach((card, i) => {
                card.onmouseover = () => { card.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'; card.querySelector('.hover-overlay').style.opacity = '1'; };
                card.onmouseout = () => { card.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)'; card.querySelector('.hover-overlay').style.opacity = '0'; };

                card.onclick = () => {
                    const item = allDocs[i];
                    // Open Viewer containing all attachments of that Specific Transaction
                    this.abrirVisualizadorAnexos(item.docList, `${item.lanc.descricao} (${dataFmt})`);
                };
            });
        };

        container.querySelector('#galeria-filtro-mes').addEventListener('change', loadDocs);

        let searchTimer;
        container.querySelector('#galeria-filtro-parceiro').addEventListener('input', () => {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(loadDocs, 500);
        });

        container.querySelector('#btn-galeria-refresh').addEventListener('click', loadDocs);

        loadDocs();
    }
});
